import React from 'react';
import PropTypes from 'prop-types';
import WidgetList from '../WidgetList/WidgetList';
import { NavigationVariants } from '../../libs/animations';
import ContainerWrapper from '../../styled components/ContainerWrapper';
import AnimatedContainer from './DashboardPage.style';
import NavigationHistory from '../../libs/NavigationHistory';
import tailwindConfig from '../../../tailwind.config';

class DashboardPage extends React.PureComponent {
  render() {
    const { navigationHistory, history } = this.props;
    /* Do not animate when first landing on this page or navigating from or to a popover page.
     *  Take into account that the user can use the back/forward mechanisms from the browser to pop all history entries */
    const isFirstPage = !history.previousURL;
    const previousPage = navigationHistory.peek();
    const shouldAnimate =
      !isFirstPage &&
      previousPage &&
      !navigationHistory.isPopoverURL(history.previousURL) &&
      !navigationHistory.isPopoverURL(previousPage.pathname);
    return (
      <AnimatedContainer
        exit={(customExitProperty) => {
          /* This can be undefined (due to rerenderings?). Should be checked. */
          if (customExitProperty !== undefined) {
            const { currentURL } = customExitProperty;
            if (navigationHistory.isPopoverURL(currentURL))
              return NavigationVariants.invisibleNoTransition;
            return NavigationVariants.moveOutLeft;
          }
        }}
        animate={shouldAnimate ? 'moveIn' : 'visible'}
        initial={shouldAnimate ? 'moveOutLeft' : 'visible'}
        variants={NavigationVariants}
      >
        <ContainerWrapper
          $paddingTop={tailwindConfig.extend.headerHeight}
          data-test-page-wrapper
        >
          <WidgetList {...this.props} />
        </ContainerWrapper>
      </AnimatedContainer>
    );
  }
}

DashboardPage.propTypes = {
  user: PropTypes.shape({
    host: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string
  }).isRequired,
  navs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      nameMessage: PropTypes.string,
      linkTo: PropTypes.string
    })
  ),
  showNotificationCenter: PropTypes.bool.isRequired,
  showSettingsCenter: PropTypes.bool.isRequired,
  routeUrlFor: PropTypes.func.isRequired,
  navigationHistory: PropTypes.instanceOf(NavigationHistory).isRequired,
  history: PropTypes.shape({
    previousURL: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
  }).isRequired
};

DashboardPage.defaultProps = {
  navs: []
};

export default DashboardPage;
